import {Base} from "@Models/Base";
import {File} from "@Models/File";
import {EventsApi, EventsBilling} from "@/api/api";

export class EventReport extends Base {
    static reportEvents(events: Record<number, EventsBilling>): Promise<File> {
        return EventsApi.exportsReport({events: events}).then(response => File.createFromResponse(response));
    }
}
